import listTemplate from './views/list.tpl.html';
import editorTemplate from './views/editor.tpl.html';
import BillingPositionsEditController from './controllers/edit-controller';
import BillingPositionsCreateController from './controllers/create-controller';

angular
    .module('festzelt-os.billing.positions')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.billing.positions', {
            abstract: true,
            url: 'positions',
            template: '<ui-view />',
            data: {
                pageTitle: 'Position',
                showBackBtn: false
            }
        })
        .state('app.billing.positions.index', {
            url: '',
            sticky: true,
            data: {
                right: 'billing::position-list',
            },
            templateUrl: listTemplate,
            controller: 'PositionListCtrl',
            controllerAs: 'vm'
        })
        .state('app.billing.positions.create', {
            url: '/create',
            data: {
                view: 'editor'
            },
            params: {
                positionCategory: undefined,
                store: undefined,
                right: 'billing::position-create',
            },
            templateUrl: editorTemplate,
            controller: BillingPositionsCreateController,
            controllerAs: 'vm'
        })
        .state('app.billing.positions.edit', {
            url: '/{id}/edit',
            params: {
                positionCategory: undefined,
                store: undefined
            },
            data: {
                right: 'billing::position-edit',
            },
            templateUrl: editorTemplate,
            controller: BillingPositionsEditController,
            controllerAs: 'vm'
        });
}



// WEBPACK FOOTER //
// ./src/app/pages/billing/positions/positions-routes.js